/**
 * HR > Directory at /hr/directory.
 *
 * The whole company: corporate nested by reporting line from the CEO down, then
 * one section per store. Contact details throughout, so this is the page you
 * come to when you need to reach somebody or reach a store.
 *
 * There is deliberately no separate Org chart page any more. The directory is
 * already ordered as one, so a second page showing the same tree was two things
 * to maintain and two things to keep in sync.
 *
 * The rendering lives in EmployeeDirectory in `@ampersandbrands/ui`, because
 * Sweet Spot shows the identical page to store staff. This file is only the
 * fetch plus the Cockpit page chrome.
 */

import { EmployeeDirectory } from '@ampersandbrands/ui';
import { useDirectory, isNotAvailable } from '@/lib/useDirectory';
import { HrHeader, NotAvailableCard, ErrorCard } from './hrShared';

export function HrDirectory() {
  const { people, stores, corporatePhone, syncedAt, isLoading, error } = useDirectory();

  return (
    <div>
      <HrHeader
        title="Directory"
        subtitle="Everyone at Ampersand Brands, corporate by reporting line and then store by store."
      />
      <EmployeeDirectory
        people={people}
        stores={stores}
        corporatePhone={corporatePhone}
        syncedAt={syncedAt}
        loading={isLoading}
        error={
          error ? (
            isNotAvailable(error) ? (
              <NotAvailableCard what="The directory" />
            ) : (
              <ErrorCard message={error.message} />
            )
          ) : null
        }
      />
    </div>
  );
}
